import styled from '@emotion/styled';

/*
 * z-index of theme not used, since this component has multiple z-index
 * that must be close, and with theme options it's possible
 * for elements to be on top of overlays
 */

const ThumbSVG = (background: string, lines: string) => {
    const svg = encodeURIComponent(
        `<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><rect width='24' height='24' fill='${background}'/><rect x='9.5' y='6' width='1' height='12' fill='${lines}'/><rect x='13.5' y='6' width='1' height='12' fill='${lines}'/></svg>`
    );
    return `url("data:image/svg+xml,${svg}")`;
};

export const StyledRangeSlider = styled.div({
    position: 'relative',
    width: '100%',
});

export const StyledSlider = styled.div({
    position: 'relative',
    width: '100%',
});

export const StyledSliderTrack = styled.div<{ disabled?: boolean }>(({ theme, disabled }) => ({
    height: '4px',
    position: 'absolute',
    backgroundColor: !disabled ? theme.colors.light50 : theme.colors.light30,
    width: '100%',
    zIndex: 1,
}));

export const StyledSliderRange = styled.div<{ disabled?: boolean }>(({ theme, disabled }) => ({
    height: '4px',
    position: 'absolute',
    backgroundColor: !disabled ? theme.colors.dark70 : theme.colors.light50,
    zIndex: 2,
}));

export const StyledSliderMinThumb = styled.input(({ theme }) => ({
    appearance: 'none',
    pointerEvents: 'none',
    position: 'absolute',
    height: 0,
    width: '100%',
    outline: 'none',
    tapHighlightColor: 'transparent',
    zIndex: 3,
    ['&::-webkit-slider-thumb']: {
        appearance: 'none',
        tapHighlightColor: 'transparent',
        height: theme.spaces[4],
        width: theme.spaces[4],
        pointerEvents: 'all',
        marginLeft: '-2px',
        position: 'relative',
        borderRadius: 0,
        outline: '4px solid transparent',
        backgroundImage: `${ThumbSVG(theme.colors.dark, theme.colors.dark50)}`,
        cursor: 'grab',
    },
    ['&::-moz-range-thumb']: {
        outline: '4px solid transparent',
        height: theme.spaces[4],
        borderRadius: 0,
        width: theme.spaces[4],
        pointerEvents: 'all',
        position: 'relative',
        marginLeft: '-2px',
        backgroundColor: 'black',
        backgroundImage: `${ThumbSVG(theme.colors.dark, theme.colors.dark50)}`,
        cursor: 'grab',
    },
    ['&:focus-visible']: {
        ['&::-moz-range-thumb']: {
            outline: `4px solid ${theme.colors.blue20}`,
        },
        ['&::-webkit-slider-thumb']: {
            outline: `4px solid ${theme.colors.blue20}`,
        },
    },
    ['&:active, &:focus:active']: {
        ['&::-moz-range-thumb']: {
            outline: `4px solid ${theme.colors.light30}`,
            cursor: 'grabbing',
        },
        ['&::-webkit-slider-thumb']: {
            outline: `4px solid ${theme.colors.light30}`,
            cursor: 'grabbing',
        },
    },
    ['&:hover']: {
        ['&::-moz-range-thumb']: {
            backgroundImage: `${ThumbSVG(theme.colors.dark, theme.colors.light30)}`,
        },
        ['&::-webkit-slider-thumb']: {
            backgroundImage: `${ThumbSVG(theme.colors.dark, theme.colors.light30)}`,
        },
    },
    ['&:disabled']: {
        ['&::-moz-range-thumb']: {
            outline: '4px solid transparent',
            cursor: 'auto',
            backgroundImage: `${ThumbSVG(theme.colors.light50, theme.colors.light30)}`,
        },
        ['&::-webkit-slider-thumb']: {
            outline: '4px solid transparent',
            cursor: 'auto',
            backgroundImage: `${ThumbSVG(theme.colors.light50, theme.colors.light30)}`,
        },
    },
}));

export const StyledSliderMaxThumb = styled(StyledSliderMinThumb)({
    zIndex: 4,
    ['&::-webkit-slider-thumb']: {
        marginLeft: '0',
    },
    ['&::-moz-range-thumb']: {
        marginLeft: '0',
    },
});
